
export default {
  name: "EtiquetaSheetPreview",
  props: {
    definition: { type: Object, required: true },
    warnings: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
  },
  computed: {
    page() {
      return this.definition.pagina || {};
    },
    label() {
      return this.definition.etiqueta || {};
    },
    pageWidth() {
      return Number(this.page.largura_mm || 50);
    },
    pageHeight() {
      return Number(this.page.altura_mm || 30);
    },
    labelWidth() {
      return Number(this.label.largura_mm || 50);
    },
    labelHeight() {
      return Number(this.label.altura_mm || 30);
    },
    columns() {
      return Math.max(1, Number(this.page.colunas || 1));
    },
    rows() {
      return Math.max(1, Number(this.page.linhas || 1));
    },
    total() {
      return this.columns * this.rows;
    },
    scale() {
      return this.compact
        ? Math.min(240 / this.pageWidth, 125 / this.pageHeight)
        : Math.min(260 / this.pageWidth, 280 / this.pageHeight);
    },
    pageStyle() {
      return {
        width: `${this.pageWidth * this.scale}px`,
        height: `${this.pageHeight * this.scale}px`,
      };
    },
    printableAreaStyle() {
      const left = Math.max(0, Number(this.page.margem_esquerda_mm || 0));
      const right = Math.max(0, Number(this.page.margem_direita_mm || 0));
      const top = Math.max(0, Number(this.page.margem_superior_mm || 0));
      const bottom = Math.max(0, Number(this.page.margem_inferior_mm || 0));
      const width = Math.max(0, this.pageWidth - left - right);
      const height = Math.max(0, this.pageHeight - top - bottom);

      return {
        left: `${Math.min(left, this.pageWidth) * this.scale}px`,
        top: `${Math.min(top, this.pageHeight) * this.scale}px`,
        width: `${width * this.scale}px`,
        height: `${height * this.scale}px`,
        zIndex: 1,
      };
    },
    positions() {
      const positions = [];
      const horizontal =
        this.labelWidth + Number(this.page.espacamento_horizontal_mm || 0);
      const vertical =
        this.labelHeight + Number(this.page.espacamento_vertical_mm || 0);
      const left = Number(this.page.margem_esquerda_mm || 0);
      const top = Number(this.page.margem_superior_mm || 0);
      let index = 0;
      for (let row = 0; row < this.rows && index < 60; row += 1) {
        for (let column = 0; column < this.columns && index < 60; column += 1) {
          positions.push({
            index,
            style: {
              left: `${(left + column * horizontal) * this.scale}px`,
              top: `${(top + row * vertical) * this.scale}px`,
              width: `${this.labelWidth * this.scale}px`,
              height: `${this.labelHeight * this.scale}px`,
              background: this.label.fundo || "#FFFFFF",
              borderColor: this.label.cor_borda || "#3f4254",
              borderWidth: `${Math.max(
                0.5,
                Number(this.label.borda_mm || 0) * this.scale
              )}px`,
              borderRadius: `${
                Number(this.label.cantos_arredondados_mm || 0) * this.scale
              }px`,
              zIndex: 2,
            },
          });
          index += 1;
        }
      }
      return positions;
    },
    miniatureElements() {
      return (this.definition.elementos || [])
        .filter((item) => item.visivel !== false)
        .slice(0, 12);
    },
  },
  methods: {
    miniatureStyle(item) {
      return {
        left: `${(Number(item.x_mm || 0) / this.labelWidth) * 100}%`,
        top: `${(Number(item.y_mm || 0) / this.labelHeight) * 100}%`,
        width: `${(Number(item.largura_mm || 0) / this.labelWidth) * 100}%`,
        height: `${(Number(item.altura_mm || 0) / this.labelHeight) * 100}%`,
        backgroundColor:
          item.tipo === "rectangle"
            ? "transparent"
            : item.estilo?.cor || "#3f4254",
        borderColor: item.estilo?.cor_borda || "#3f4254",
      };
    },
  },
};
